import { gql } from '../../../../../hooks'

export const DELETE_SITES = gql`
  mutation AdministrationDeleteClientSites($id: ID!) {
    aDelete(path: "client/sites", id: $id) {
    }
  }
`

export const LIST_SITES = gql`
  query AdministrationListClientSites(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(path: "client/sites", filter: $filter, page: $page, limit: $limit) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
